import { createReducer } from './utils.js';
import {
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  GET_USER_MESSAGES_REQUEST,
  GET_USER_MESSAGES_SUCCESS,
  GET_USER_MESSAGES_FAILURE,
  SEND_CUSTOM_MESSAGE_REQUEST,
  SEND_CUSTOM_MESSAGE_SUCCESS,
  SEND_CUSTOM_MESSAGE_FAILURE,
  USER_PROFILE_REQUEST,
  USER_PROFILE_AVAILABLE,
  USER_PROFILE_UNAVAILABLE,
  USER_ROLES_REQUEST,
  USER_ROLES_AVAILABLE,
  USER_ROLES_UNAVAILABLE,
  SET_PROFILE,
  SNACK_SET,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_LOGOUT,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_UPDATE_PROFILE_FAILURE,
  GET_CONVERSATION_REQUEST,
  GET_CONVERSATION_SUCCESS,
  GET_CONVERSATION_FAILURE,
  UPDATE_CONVERSATION_REQUEST,
  UPDATE_CONVERSATION_SUCCESS,
  UPDATE_CONVERSATION_FAILURE,
} from './constants.js';

const defaultState = {
  loading: false,
  errorMessage: null,
  users: [],
  number_of_unread_messages: 0,
  roles: '',
  messages: [],
  profile: {},
  loading_profile: true,
  loading_roles: false,
  isAuthenticated: false,
  authLoading: false,
  authError: null,
  conversation: {},
};

export const reducer = createReducer(defaultState, {
  [GET_USERS_REQUEST]: handleGetUsersRequest,
  [GET_USERS_SUCCESS]: handleGetUsersSuccess,
  [GET_USERS_FAILURE]: handleGetUsersFailure,
  [GET_USER_MESSAGES_REQUEST]: handleGetUserMessagesRequest,
  [GET_USER_MESSAGES_SUCCESS]: handleGetUserMessagesSuccess,
  [GET_USER_MESSAGES_FAILURE]: handleGetUserMessagesFailure,
  [SEND_CUSTOM_MESSAGE_REQUEST]: handleSendCustomMessageRequest,
  [SEND_CUSTOM_MESSAGE_SUCCESS]: handleSendCustomMessageSuccess,
  [SEND_CUSTOM_MESSAGE_FAILURE]: handleSendCustomMessageFailure,
  [USER_PROFILE_REQUEST]: handleProfileRequest,
  [USER_PROFILE_AVAILABLE]: handleProfileAvailable,
  [USER_PROFILE_UNAVAILABLE]: handleProfileUnavailable,
  [USER_ROLES_REQUEST]: handleRoleRequest,
  [USER_ROLES_AVAILABLE]: handleRoleAvailable,
  [USER_ROLES_UNAVAILABLE]: handleRoleUnavailable,
  [SET_PROFILE]: handleSetProfile,
  [USER_LOGIN_REQUEST]: handleLoginRequest,
  [USER_LOGIN_SUCCESS]: handleLoginSuccess,
  [USER_LOGIN_FAILURE]: handleLoginFailure,
  [USER_LOGOUT]: handleLogout,
  [USER_UPDATE_PROFILE_REQUEST]: handleUpdateProfileRequest,
  [USER_UPDATE_PROFILE_SUCCESS]: handleUpdateProfileSuccess,
  [USER_UPDATE_PROFILE_FAILURE]: handleUpdateProfileFailure,
  [GET_CONVERSATION_REQUEST]: handleGetConversationRequest,
  [GET_CONVERSATION_SUCCESS]: handleGetConversationSuccess,
  [GET_CONVERSATION_FAILURE]: handleGetConversationFailure,
  [UPDATE_CONVERSATION_REQUEST]: handleUpdateConversationRequest,
  [UPDATE_CONVERSATION_SUCCESS]: handleUpdateConversationSuccess,
  [UPDATE_CONVERSATION_FAILURE]: handleUpdateConversationFailure,
});

function handleGetUsersRequest(state) {
  return {
    ...state,
    users: [],
    number_of_unread_messages: 0,
    loading: true,
  };
}

function handleGetUsersSuccess(state, { payload: { users } }) {
  return {
    ...state,
    users: users.profiles,
    number_of_unread_messages: users.number_of_unread_messages,
    loading: false,
    errorMessage: null,
  };
}

function handleGetUsersFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}

function handleGetUserMessagesRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function handleGetUserMessagesSuccess(state, { payload: { messages } }) {
  return {
    ...state,
    messages,
    loading: false,
    errorMessage: null,
  };
}

function handleGetUserMessagesFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}

function handleSendCustomMessageRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function handleSendCustomMessageSuccess(state) {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleSendCustomMessageFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}

function handleProfileRequest(state, _) {
  return {
    ...state,
    loading_profile: true,
  };
}

function handleProfileAvailable(state, { payload: { profile } }) {
  return {
    ...state,
    profile: profile,
    sucursal_id: profile?.sucursales
      ? profile.sucursales[0]?.sucursal_id
      : null,
    loading_profile: false,
    profileState: true,
  };
}

function handleProfileUnavailable(state, _) {
  return {
    ...state,
    loading_profile: false,
    profileState: false,
  };
}

function handleRoleRequest(state, _) {
  return {
    ...state,
    loading_roles: true,
  };
}

function handleRoleAvailable(state, { payload: { roles } }) {
  return {
    ...state,
    roles: roles,
    loading_roles: false,
  };
}

function handleRoleUnavailable(state, _) {
  return {
    ...state,
    loading_roles: false,
  };
}

function handleSetProfile(state, { payload: { sucursal_id } }) {
  return {
    ...state,
    sucursal_id: sucursal_id,
  };
}

function handleLoginRequest(state) {
  return {
    ...state,
    authLoading: true,
    authError: null,
  };
}

function handleLoginSuccess(state) {
  return {
    ...state,
    isAuthenticated: true,
    authLoading: false,
    authError: null,
  };
}

function handleLoginFailure(state, { payload: { error } }) {
  return {
    ...state,
    isAuthenticated: false,
    authLoading: false,
    authError: error,
  };
}

function handleLogout(state) {
  return {
    ...state,
    isAuthenticated: false,
    profile: {},
    loading_profile: true,
  };
}

function handleUpdateProfileRequest(state) {
  return {
    ...state,
    loading: true,
    errorMessage: null,
  };
}

function handleUpdateProfileSuccess(state, { payload: { user } }) {
  return {
    ...state,
    profile: {
      ...state.profile,
      ...user
    },
    loading: false,
    errorMessage: null,
  };
}

function handleUpdateProfileFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}


function handleUpdateConversationRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function handleUpdateConversationSuccess(state) {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleUpdateConversationFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}


function handleGetConversationRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function handleGetConversationSuccess(state, { payload: { conversation } }) {
  return {
    ...state,
    conversation,
    loading: false,
  };
}

function handleGetConversationFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}

export function setSucursalId(sucursal_id) {
  return async (dispatch, getState) => {
    dispatch({
      type: SET_PROFILE,
      payload: { sucursal_id },
    });
  };
}

export function getUsers(tenant_id, sucursal_id, conversation_id) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: GET_USERS_REQUEST });
    try {
      const users = await dataSource.getUsers(
        tenant_id,
        sucursal_id,
        conversation_id,
      );
      dispatch({
        type: GET_USERS_SUCCESS,
        payload: { users },
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: GET_USERS_FAILURE,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'Error al obtener usuarios' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getUserMessages(
  user_id,
  tenant_id,
  sucursal_id,
  conversation_id,
) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: GET_USER_MESSAGES_REQUEST });
    try {
      const messages = await dataSource.getUserMessages(
        user_id,
        tenant_id,
        sucursal_id,
        conversation_id,
      );
      dispatch({
        type: GET_USER_MESSAGES_SUCCESS,
        payload: { messages },
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: GET_USER_MESSAGES_FAILURE,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'Error al obtener mensajes' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function sendCustomMessage(body) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: SEND_CUSTOM_MESSAGE_REQUEST });
    try {
      await dataSource.sendCustomMessage(body);
      dispatch({
        type: SEND_CUSTOM_MESSAGE_SUCCESS,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: SEND_CUSTOM_MESSAGE_FAILURE,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'Error al enviar mensaje' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getProfile() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    try {
      dispatch({ type: USER_PROFILE_REQUEST });
      const profile = await dataSource.getProfile();
      dispatch({
        type: USER_PROFILE_AVAILABLE,
        payload: { profile },
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: USER_PROFILE_UNAVAILABLE,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'Error al obtener el perfil' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function login(credentials) {
  return async (dispatch, getState, { services: { dataSource, authService } }) => {
    dispatch({ type: USER_LOGIN_REQUEST });
    try {
      const authData = await dataSource.login(credentials);
      
      authService.setAuthTokens(authData.access, authData.refresh);
      
      authService.setUserData(authData.user);
      
      dispatch({ type: USER_LOGIN_SUCCESS });
      
      dispatch(getProfile());
      
      return true;
    } catch (error) {
      console.log(error);
      dispatch({
        type: USER_LOGIN_FAILURE,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'Error al iniciar sesión: ' + (error.message || 'Credenciales inválidas'),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
      return false;
    }
  };
}

export function logout() {
  return (dispatch, getState, { services: { authService } }) => {
    authService.clearTokens();
    
    dispatch({ type: USER_LOGOUT });
    
    // The redirection will be handled by the component using the isAuthenticated state
  };
}

export function checkAuth() {
  return (dispatch, getState, { services: { authService } }) => {
    if (authService.isAuthenticated()) {
      // Usuario ya autenticado con token en localStorage
      dispatch({ type: USER_LOGIN_SUCCESS });
      // Cargar el perfil del usuario
      dispatch(getProfile());
    }
  };
}

export function updateUserProfile(userData) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: USER_UPDATE_PROFILE_REQUEST });
    
    try {
      const user = await dataSource.updateUserProfile(userData);
      
      dispatch({
        type: USER_UPDATE_PROFILE_SUCCESS,
        payload: { user }
      });

      const snack = {
        open: true,
        message: 'Perfil actualizado con éxito',
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });  
      
      return user;
    } catch (error) {
      console.log(error);
      dispatch({
        type: USER_UPDATE_PROFILE_FAILURE,
        payload: { error: error.message || 'Error al actualizar el perfil' },
      });
      
      const snack = {
        open: true,
        message: 'Error al actualizar el perfil ' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getConversation(user_id, tenant_id, sucursal_id) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: GET_CONVERSATION_REQUEST });
    
    try {
      const conversation = await dataSource.getConversation(user_id, tenant_id, sucursal_id);
      dispatch({ type: GET_CONVERSATION_SUCCESS, payload: { conversation } });
    } catch (error) {
      console.log(error);
      dispatch({
        type: GET_CONVERSATION_FAILURE,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'Error al obtener la conversación: ' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}


export function updateConversation(body) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: UPDATE_CONVERSATION_REQUEST });
    try {
      await dataSource.updateConversation(body);
      dispatch({
        type: UPDATE_CONVERSATION_SUCCESS,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: UPDATE_CONVERSATION_FAILURE,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'Error al actualizar el estado del mensaje: ' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}